import { render, staticRenderFns } from "./ChoosableColumns.vue?vue&type=template&id=502acc80"
import script from "./ChoosableColumns.vue?vue&type=script&lang=js"
export * from "./ChoosableColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports